import IssuePreviewModal from './IssuePreviewModal';

export default IssuePreviewModal;
